// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_3OYGH","withBorder":"_18z3l","memberInitials":"_1EdKQ","avatarPlaceholder":"KkkFB"};